import { CHAT_QUERY_KEY } from "@frontend-shared/constants";
import { useQuery } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

export const useGetChatByUuid = (uuid?: string) => {
  return useQuery({
    queryKey: [CHAT_QUERY_KEY, uuid],
    // NOTE: since we disable this query when uuid is undefined, we can safely use the ! operator here
    queryFn: () => chatApi.getChatByUuid(uuid!),
    enabled: !!uuid,
  });
};
